// components/company/CompanyOverviewCard.tsx

import { DefinitionListCard } from "@components/reputation/DefinitionListCard";
import { Chip } from "@material-ui/core";
import { CompanyReputation } from "../../types";

export const CompanyOverviewCard: React.FC<{
  company: CompanyReputation;
}> = ({ company }) => {
  return (
    <DefinitionListCard
      title="Company Overview"
      columns={2}
      items={[
      /*   { label: "VTR ID", value: company.vtr_id }, */
        { label: "Company Name", value: company.name },
        {
          label: "Status",
          value: company.company_status ? (
            <Chip
              size="small"
              label={company.company_status}
              style={{ marginRight: 10, backgroundColor: "#f29e9e" }}
            />
          ) : (
            "-"
          ),
        },
        {
          label: "Active",
          value: company.company_active ? (
            <Chip
              size="small"
              color="primary"
              label={company.company_active}
              style={{ marginRight: 10, backgroundColor: "#4ebeb4" }}
            />
          ) : (
            "-"
          ),
        },
        { label: "Offices", value: company.offices_count },
        { label: "Clients", value: company.clients_count },
        { label: "Employees (Max)", value: company.max_emp_count },
        { label: "Parent Companies", value: company.parent_companies_count },
        { label: "Child Companies", value: company.child_companies_count },
        { label: "Overall Deals", value: company.overall_deals },
        { label: "Projects (2000+)", value: company.projects_count_2000 },
      ]}
    />
  );
};
